type PremiumAccountType = 'guest' | 'account' | 'anonymous' | 'unknown';
let accountTypeSource: () => PremiumAccountType = () => 'unknown';

/** Read the current session at event time, including after profile switches. */
export function setPremiumAccountTypeSource(source: () => PremiumAccountType): void {
  accountTypeSource = source;
}

export function analyticsAccountType(): PremiumAccountType { return accountTypeSource(); }
